module.exports = __webpack_public_path__ + "img/zip.4d210c14.png";